﻿﻿import { PreWorkupLabJugStatus } from '../enums/index';

export interface IPreWorkupLabDetails {
    jugStatus: PreWorkupLabJugStatus;
    preWorkupLabStartDate: Date;
    isManualPwlRequest: boolean;
    jugReceivedDateTime: Date;
    labOrderRequisitionNumber: string;
    labOrderRepeatReason: string;
    labOrderRepeatTests: string;
    scripBatchFile: string;
    scripUploadFile: string;
    scripRequestedDateTime: Date;
    scripUploadedDateTime: Date;
    scripExpirationDate: Date;
    questCompletedDate: Date;
    questCompletedWhere: string;
    phlebotRequestedDateTime: Date;
    labsUploadFile: string;
    labsUploadedDateTime: Date;
}
